import React from "react";
import { observer } from "mobx-react";
import useToggleState from "components/hooks/useToggleState";
import ModalPopup from "components/modal";
import UI from "components/UI";
import Button from "components/buttons";
import TbComFile from "domain/main/com/file/TbComFile";
import commonPopupStore from "../store/CommonPopupStore";
import {UIRaonKFileUploadProps} from "../../../types/KFileUploadType";

export interface PopupFileUploadParam extends UIRaonKFileUploadProps{
    title: string;
    buttonTitle: string;
    valueChanged: (value?:TbComFile) => void;
}
export default observer(PopupFileUpload);

function PopupFileUpload(prop: PopupFileUploadParam) {
    const title = prop.title === undefined ? "파일 업로드" : prop.title;
    const buttonTitle = prop.buttonTitle === undefined ? "등록" : prop.buttonTitle;

    const [uploadId, setUploadId] = React.useState<string>();
    const modalState = useToggleState({showing: true});

    const handleClose = () => {
        (async () => prop.valueChanged(undefined))();
        (async () => modalState.toggle())();
    }

    const onCreationComplete = function (uploadID: string) {
        setUploadId(uploadID);
    }

    const valueChanged = (value: TbComFile) => {
        (async () => prop.valueChanged(value))();
        (async () => modalState.toggle())();
    }

    const doTransfer = () => {
        if(uploadId)
            window["RAONKUPLOAD"].Transfer(uploadId);
    }

    return (
        <ModalPopup
            open={modalState.isShowing}
            title={title}
            size="mid"
            onClose={handleClose}
            onAfterClose={()=>{commonPopupStore.closeLastPopup()}}
        >
            <div className="modal-con">
                <UI.FileUpload
                    attrs={prop.attrs}
                    onCreationComplete={onCreationComplete}
                    valueChanged={valueChanged}
                />
            </div>
            <div className="modal-bottom">
                <Button color='pri' size="md" onClick={doTransfer}>{buttonTitle}</Button>
            </div>
        </ModalPopup>
    )
}
